import { Component } from '@angular/core';
import { BlacklistPhoneNumber } from '../../models/blacklist-phone-number.model';
import { PaginatedBlacklistPhoneNumbers } from '../../interfaces/paginated-blacklist-phone-numbers.interface';
import { BlacklistService } from '../../services/blacklist.service';
import { generatePagination } from '../../utils/pagination.utils';
import { PaginatedBlacklistUsers } from '../../interfaces/paginated-blacklist-users.interface';
import { BlacklistUser } from '../../models/blacklist-user.model';

@Component({
  selector: 'app-blacklist-user',
  standalone: false,
  templateUrl: './blacklist-user.component.html',
  styleUrl: './blacklist-user.component.css'
})
export class BlacklistUserComponent {
  blacklistPhoneNumbers: BlacklistUser[] = [];
  nextPageUrl: string | null = null;
  previousPageUrl: string | null = null;
  currentPage = 1;
  totalPages = 1;
  pageNumbers: any = [];
  searchQuery: string = '';
  submitted = false;
  showAddPhoneNumberModal = false;
  newPhoneNumber: string = '';

  constructor(
    private blacklistService: BlacklistService,
  ) {}

  ngOnInit() {
    this.loadBlacklists(this.currentPage);
  }

  reset() {
    this.blacklistPhoneNumbers = [];
    this.nextPageUrl = null;
    this.previousPageUrl = null;
    this.currentPage = 1;
    this.totalPages = 1;
    this.pageNumbers = [];
  }

  loadBlacklists(page: number) {
    this.reset();
    this.submitted = true;

    this.blacklistService.getBlacklistUsers(page, this.searchQuery).subscribe(
      (response: PaginatedBlacklistUsers) => {
        this.blacklistPhoneNumbers = response.results;
        this.nextPageUrl = response.next;
        this.previousPageUrl = response.previous;
        this.currentPage = page;

        const itemsPerPage = 20;
        this.totalPages = Math.ceil(response.count / itemsPerPage);
        this.pageNumbers = generatePagination(this.currentPage, this.totalPages);
        this.submitted = false;
      }
    );
  }

  goToNextPage() {
    if (this.nextPageUrl) {
      this.loadBlacklists(this.currentPage + 1);
    }
  }

  goToPreviousPage() {
    if (this.previousPageUrl) {
      this.loadBlacklists(this.currentPage - 1);
    }
  }

  goToPage(page: number) {
    this.loadBlacklists(page);
  }

  onSearchChange() {
    this.loadBlacklists(1); // Reset to first page on search
  }

  openAddPhoneNumberModal() {
    this.showAddPhoneNumberModal = true;
    this.newPhoneNumber = ''; // Clear previous input
  }

  closeAddPhoneNumberModal() {
    this.showAddPhoneNumberModal = false;
  }

  addPhoneNumber() {
    if (this.newPhoneNumber) {
      this.blacklistService.addBlacklistedPhoneNumber(this.newPhoneNumber).subscribe(
        () => {
          this.loadBlacklists(this.currentPage);
          this.closeAddPhoneNumberModal();
        },
        error => {
          console.error('Error adding phone number:', error);
          // Handle error (e.g., show a message to the user)
        }
      );
    }
  }

  deletePhoneNumber(id: string) {
    if (window.confirm('Are you sure you want to delete this phone number from the blacklist?')) {
      this.blacklistService.deleteBlacklistedPhoneNumber(id).subscribe(
        () => {
          this.loadBlacklists(this.currentPage);
        },
        error => {
          console.error('Error deleting phone number:', error);
          // Handle error
        }
      );
    }
  }
}
